module.exports = __webpack_public_path__ + "static/img/tuopukang.bb54fae4.png";